<template>
  <div id="landingpage">
    <h1 class="tamani">TAMANI<span class="restaurant">BOOK</span></h1>

    <div class="share-btn">    
      <div class="social-links">
          <a href="https://twitter.com/tamani_cafe">
            <div id="twitter" class="social-btn flex-center">
              <svg viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path></svg><span>@Tamani_Cafe</span>
            </div>
          </a>
      
          <a href="https://www.instagram.com/tamani_cafe/">
            <div id="instagram" class="social-btn flex-center">
              <svg width="64px" height="64px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect x="2" y="2" width="28" height="28" rx="6" fill="url(#paint0_radial_87_7153)"></rect> <rect x="2" y="2" width="28" height="28" rx="6" fill="url(#paint1_radial_87_7153)"></rect> <rect x="2" y="2" width="28" height="28" rx="6" fill="url(#paint2_radial_87_7153)"></rect> <path d="M23 10.5C23 11.3284 22.3284 12 21.5 12C20.6716 12 20 11.3284 20 10.5C20 9.67157 20.6716 9 21.5 9C22.3284 9 23 9.67157 23 10.5Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M6 15.6C6 12.2397 6 10.5595 6.65396 9.27606C7.2292 8.14708 8.14708 7.2292 9.27606 6.65396C10.5595 6 12.2397 6 15.6 6H16.4C19.7603 6 21.4405 6 22.7239 6.65396C23.8529 7.2292 24.7708 8.14708 25.346 9.27606C26 10.5595 26 12.2397 26 15.6V16.4C26 19.7603 26 21.4405 25.346 22.7239C24.7708 23.8529 23.8529 24.7708 22.7239 25.346C21.4405 26 19.7603 26 16.4 26H15.6C12.2397 26 10.5595 26 9.27606 25.346C8.14708 24.7708 7.2292 23.8529 6.65396 22.7239C6 21.4405 6 19.7603 6 16.4V15.6ZM15.6 8H16.4C18.1132 8 19.2777 8.00156 20.1779 8.0751C21.0548 8.14674 21.5032 8.27659 21.816 8.43597C22.5686 8.81947 23.1805 9.43139 23.564 10.184C23.7234 10.4968 23.8533 10.9452 23.9249 11.8221C23.9984 12.7223 24 13.8868 24 15.6V16.4C24 18.1132 23.9984 19.2777 23.9249 20.1779C23.8533 21.0548 23.7234 21.5032 23.564 21.816C23.1805 22.5686 22.5686 23.1805 21.816 23.564C21.5032 23.7234 21.0548 23.8533 20.1779 23.9249C19.2777 23.9984 18.1132 24 16.4 24H15.6C13.8868 24 12.7223 23.9984 11.8221 23.9249C10.9452 23.8533 10.4968 23.7234 10.184 23.564C9.43139 23.1805 8.81947 22.5686 8.43597 21.816C8.27659 21.5032 8.14674 21.0548 8.0751 20.1779C8.00156 19.2777 8 18.1132 8 16.4V15.6C8 13.8868 8.00156 12.7223 8.0751 11.8221C8.14674 10.9452 8.27659 10.4968 8.43597 10.184C8.81947 9.43139 9.43139 8.81947 10.184 8.43597C10.4968 8.27659 10.9452 8.14674 11.8221 8.0751C12.7223 8.00156 13.8868 8 15.6 8Z" fill="white"></path> <defs> <radialGradient id="paint0_radial_87_7153" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12 23) rotate(-55.3758) scale(25.5196)"> <stop stop-color="#B13589"></stop> <stop offset="0.79309" stop-color="#C62F94"></stop> <stop offset="1" stop-color="#8A3AC8"></stop> </radialGradient> <radialGradient id="paint1_radial_87_7153" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11 31) rotate(-65.1363) scale(22.5942)"> <stop stop-color="#E0E8B7"></stop> <stop offset="0.444662" stop-color="#FB8A2E"></stop> <stop offset="0.71474" stop-color="#E2425C"></stop> <stop offset="1" stop-color="#E2425C" stop-opacity="0"></stop> </radialGradient> <radialGradient id="paint2_radial_87_7153" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(0.500002 3) rotate(-8.1301) scale(38.8909 8.31836)"> <stop offset="0.156701" stop-color="#406ADC"></stop> <stop offset="0.467799" stop-color="#6A45BE"></stop> <stop offset="1" stop-color="#6A45BE" stop-opacity="0"></stop> </radialGradient> </defs> </g></svg><span>@tamani_cafe</span>
            </div> 
          </a>

          <a href="https://www.facebook.com/Fp.TamaniCafe/?locale=id_ID">  
              <div id="facebook" class="social-btn flex-center">
                  <svg viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>Facebook-color</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Color-" transform="translate(-200.000000, -160.000000)" fill="#243f7f"> <path d="M225.638355,208 L202.649232,208 C201.185673,208 200,206.813592 200,205.350603 L200,162.649211 C200,161.18585 201.185859,160 202.649232,160 L245.350955,160 C246.813955,160 248,161.18585 248,162.649211 L248,205.350603 C248,206.813778 246.813769,208 245.350955,208 L233.119305,208 L233.119305,189.411755 L239.358521,189.411755 L240.292755,182.167586 L233.119305,182.167586 L233.119305,177.542641 C233.119305,175.445287 233.701712,174.01601 236.70929,174.01601 L240.545311,174.014333 L240.545311,167.535091 C239.881886,167.446808 237.604784,167.24957 234.955552,167.24957 C229.424834,167.24957 225.638355,170.625526 225.638355,176.825209 L225.638355,182.167586 L219.383122,182.167586 L219.383122,189.411755 L225.638355,189.411755 L225.638355,208 L225.638355,208 Z" id="Facebook"> </path> </g> </g> </g></svg><span>Tamani Cafe</span>
              </div>
          </a>
      </div>
    </div>

    <div v-show="screenposition >= 640" class="btn-top">
      <a href="#first-section" class="Btn">
        <svg height="1.2em" class="arrow" viewBox="0 0 512 512"><path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"></path></svg>
        <p class="text">Back to Top</p>
      </a>
    </div>

    <div class="first-page">
      <div class="landing-section" id="first-section">
          <div class="wrap">
              <div class="box">
                  <h1>Self Ordering System <strong>QR</strong>Code</h1>
                  <p>A better way to serve our food menu using fully featured Tamani Book Apps,
                  <br>Self-service system that empowers customers to make their own food orders directly on their smartphone without the involvement of a restaurant cashier or waiter</p> 
                  <a href="#second-section" class="btn navigation-btn"><span class="icon flaticon-download7"></span>See Details</a> </div>
          </div>
      </div>
    </div>
    <div class="second-page">
      <div class="landing-section" id="second-section">
          <div class="wrap">
              <div class="box" style="margin-top: -20%;">
                  <h1>About <strong>Apps</strong></h1>
                  <p>TamaniBook does not need to be installed on your device, it's running on cloud!</p> 
                  
                  <div class="about-card-container">
                    <div class="about-buttons">
                      <a @click="first" class="about-button first" :class="{'active' : isActive === 'first'}">
                        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect x="0" fill="none" width="20" height="20"></rect> <g> <path d="M13 13.14l1.17-5.94c.79-.43 1.33-1.25 1.33-2.2 0-1.38-1.12-2.5-2.5-2.5S10.5 3.62 10.5 5c0 .95.54 1.77 1.33 2.2zm0-9.64c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm1.72 4.8L18 6.97v9L13.12 18 7 15.97l-5 2v-9l5-2 4.27 1.41 1.73 7.3z"></path> </g> </g></svg>
                      </a>
                      <a @click="second" class="about-button second" :class="{'active' : isActive === 'second'}">
                        <svg fill="#000000" height="200px" width="200px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 325.04 325.04" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M117.866,234.088c-2.956,14.532-4.875,21.558-16.092,22.458c-2.764,0.222-5.015,2.308-5.446,5.047 c-0.432,2.738,1.069,5.416,3.631,6.477c0.721,0.298,17.877,7.308,37.921,7.309c0.003,0,0.005,0,0.007,0 c13.968,0,25.95-3.386,35.612-10.063c11.45-7.912,19.344-20.294,23.541-36.788l-38.572-38.88 C125.871,194.924,121.253,217.436,117.866,234.088z"></path> <path d="M322.745,63.336c-1.037-1.046-2.887-2.293-5.806-2.293c-3.423,0-12.516,0-67.74,46.992 c-25.509,21.706-54.92,48.559-78.314,71.41l36.603,36.894c24.061-25.009,52.129-56.355,74.451-83.258 c14.096-16.986,24.935-31.002,32.216-41.657C323.799,77.311,328.023,68.655,322.745,63.336z"></path> <path d="M182.595,278.479c-12.387,8.56-27.429,12.899-44.716,12.899c-22.753-0.001-41.919-7.649-44.046-8.527 c-9.425-3.906-14.898-13.673-13.31-23.749c1.555-9.871,9.463-17.373,19.341-18.446c0.861-2.571,1.813-7.254,2.323-9.758 c1.878-9.23,4.449-21.873,12.358-33.126c8.637-12.287,21.656-20.165,38.751-23.466c9.811-9.737,21.005-20.443,32.686-31.308 c-5.905-1.281-11.185-5.127-14.017-10.944c-4.875-10.02-0.623-22.073,9.484-26.895c10.133-4.834,22.287-0.612,27.155,9.423 c0.961,1.978,1.555,4.033,1.832,6.096c9.688-8.677,19.309-17.099,28.392-24.828c0.054-0.046,0.105-0.09,0.16-0.136 c-10.209-19.536-24.849-36.845-42.687-50.098c-25.614-19.031-56.114-29.096-88.2-29.104c-0.01,0-0.017,0-0.025,0 c-21.654,0-47.976,7.566-68.697,19.749C13.981,51.193-0.005,71.163,0,92.49c0.008,25.748,14.53,36.518,26.199,45.171 c9.515,7.057,17.03,12.63,17.034,24.844c0.003,12.213-7.508,17.781-17.018,24.831c-11.665,8.648-26.184,19.412-26.176,45.163 c0.006,21.324,14.001,41.299,39.406,56.244c20.736,12.198,47.072,19.78,68.73,19.786c0.015,0,0.028,0,0.042,0 c39.305,0,76.254-15.171,104.044-42.72c20.837-20.655,34.656-46.416,40.273-74.442c-13.952,15.471-27.997,30.493-40.563,43.322 C206.641,253.965,196.773,268.682,182.595,278.479z M111.054,77.103c2.498-10.871,13.4-17.657,24.354-15.167 c10.939,2.478,17.793,13.282,15.313,24.138c-2.499,10.844-13.407,17.631-24.362,15.154 C115.411,98.764,108.554,87.947,111.054,77.103z M45.054,114.152c-7.005-8.716-5.565-21.401,3.216-28.339 c8.78-6.925,21.571-5.505,28.589,3.195c6.99,8.703,5.545,21.388-3.229,28.34C64.869,124.288,52.058,122.853,45.054,114.152z M55.746,247.168c-8.786-6.944-10.231-19.629-3.226-28.342c7-8.696,19.796-10.122,28.581-3.18 c8.778,6.943,10.224,19.629,3.225,28.327C77.327,252.686,64.53,254.111,55.746,247.168z"></path> </g> </g></svg>
                      </a>
                      <a @click="third" class="about-button third" :class="{'active' : isActive === 'third'}">
                        <svg viewBox="0 0 600 600" version="1.1" id="svg9724" sodipodi:docname="settings2.svg" inkscape:version="1.2.2 (1:1.2.2+202212051550+b0a8486541)" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs id="defs9728"></defs> <sodipodi:namedview id="namedview9726" pagecolor="#ffffff" bordercolor="#666666" borderopacity="1.0" inkscape:showpageshadow="2" inkscape:pageopacity="0.0" inkscape:pagecheckerboard="0" inkscape:deskcolor="#d1d1d1" showgrid="true" inkscape:zoom="0.59480855" inkscape:cx="44.55215" inkscape:cy="332.03961" inkscape:window-width="1920" inkscape:window-height="1009" inkscape:window-x="0" inkscape:window-y="1080" inkscape:window-maximized="1" inkscape:current-layer="svg9724" showguides="true"> <inkscape:grid type="xygrid" id="grid9972" originx="0" originy="0"></inkscape:grid> <sodipodi:guide position="40,400" orientation="0,-1" id="guide292" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="90,200" orientation="0,-1" id="guide294" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="230,500" orientation="0,-1" id="guide296" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="210,300" orientation="0,-1" id="guide298" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="230,100" orientation="0,-1" id="guide300" inkscape:locked="false"></sodipodi:guide> </sodipodi:namedview> <g id="g10449" transform="matrix(0.95173205,0,0,0.95115787,13.901174,12.168794)" style="stroke-width:1.05103"> <path id="path356" style="color:#000000;fill:#000000;stroke-linecap:round;-inkscape-stroke:none" d="M 447.70881 -12.781343 A 42.041451 42.041451 0 0 0 405.66786 29.260344 L 405.66786 50.301721 L 27.434765 50.301721 A 42.041302 42.041302 0 0 0 -14.606185 92.341354 A 42.041302 42.041302 0 0 0 27.434765 134.38304 L 405.66786 134.38304 L 405.66786 155.44906 A 42.041451 42.041451 0 0 0 447.70881 197.49075 A 42.041451 42.041451 0 0 0 489.74976 155.44906 L 489.74976 134.38304 L 573.78036 134.38304 A 42.041302 42.041302 0 0 0 615.82336 92.341354 A 42.041302 42.041302 0 0 0 573.78036 50.301721 L 489.74976 50.301721 L 489.74976 29.260344 A 42.041451 42.041451 0 0 0 447.70881 -12.781343 z M 143.0012 197.48869 A 42.041451 42.041451 0 0 0 100.9582 239.53038 L 100.9582 260.5697 L 27.447078 260.5697 A 42.041302 42.041302 0 0 0 -14.593872 302.61139 A 42.041302 42.041302 0 0 0 27.447078 344.65308 L 100.9582 344.65308 L 100.9582 365.7191 A 42.041451 42.041451 0 0 0 143.0012 407.76078 A 42.041451 42.041451 0 0 0 185.04215 365.7191 L 185.04215 344.65308 L 573.79472 344.65308 A 42.041302 42.041302 0 0 0 615.83567 302.61139 A 42.041302 42.041302 0 0 0 573.79472 260.5697 L 185.04215 260.5697 L 185.04215 239.53038 A 42.041451 42.041451 0 0 0 143.0012 197.48869 z M 279.59427 407.76078 A 42.041451 42.041451 0 0 0 237.55332 449.80042 L 237.55332 470.83974 L 27.447078 470.83974 A 42.041302 42.041302 0 0 0 -14.593872 512.88143 A 42.041302 42.041302 0 0 0 27.447078 554.92106 L 237.55332 554.92106 L 237.55332 575.98913 A 42.041451 42.041451 0 0 0 279.59427 618.02877 A 42.041451 42.041451 0 0 0 321.63522 575.98913 L 321.63522 554.92106 L 573.79472 554.92106 A 42.041302 42.041302 0 0 0 615.83567 512.88143 A 42.041302 42.041302 0 0 0 573.79472 470.83974 L 321.63522 470.83974 L 321.63522 449.80042 A 42.041451 42.041451 0 0 0 279.59427 407.76078 z "></path> </g> </g></svg>
                      </a>
                      <a @click="fourth" class="about-button fourth" :class="{'active' : isActive === 'fourth'}">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10.25 10.03C10.25 10.57 10.4 10.65 10.74 10.77L11.25 10.95V9.25H10.95C10.57 9.25 10.25 9.6 10.25 10.03Z" fill="#292D32"></path> <path d="M12.75 14.7508H13.05C13.44 14.7508 13.75 14.4008 13.75 13.9708C13.75 13.4308 13.6 13.3508 13.26 13.2308L12.75 13.0508V14.7508Z" fill="#292D32"></path> <path d="M19.58 5.48L17.53 7.53C17.38 7.68 17.19 7.75 17 7.75C16.81 7.75 16.62 7.68 16.47 7.53C16.18 7.24 16.18 6.76 16.47 6.47L18.52 4.42C16.76 2.92 14.49 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 9.51 21.08 7.24 19.58 5.48ZM13.75 11.82C14.39 12.05 15.25 12.51 15.25 13.98C15.25 15.23 14.26 16.26 13.05 16.26H12.75V16.51C12.75 16.92 12.41 17.26 12 17.26C11.59 17.26 11.25 16.92 11.25 16.51V16.26H11.17C9.84 16.26 8.75 15.14 8.75 13.76C8.75 13.34 9.09 13 9.5 13C9.91 13 10.25 13.34 10.25 13.75C10.25 14.3 10.66 14.75 11.17 14.75H11.25V12.53L10.25 12.18C9.61 11.95 8.75 11.49 8.75 10.02C8.75 8.77 9.74 7.74 10.95 7.74H11.25V7.5C11.25 7.09 11.59 6.75 12 6.75C12.41 6.75 12.75 7.09 12.75 7.5V7.75H12.83C14.16 7.75 15.25 8.87 15.25 10.25C15.25 10.66 14.91 11 14.5 11C14.09 11 13.75 10.66 13.75 10.25C13.75 9.7 13.34 9.25 12.83 9.25H12.75V11.47L13.75 11.82Z" fill="#292D32"></path> <path d="M22.69 1.71C22.61 1.53 22.47 1.38 22.28 1.3C22.19 1.27 22.1 1.25 22 1.25H18C17.59 1.25 17.25 1.59 17.25 2C17.25 2.41 17.59 2.75 18 2.75H20.19L18.52 4.42C18.9 4.75 19.25 5.1 19.58 5.48L21.25 3.81V6C21.25 6.41 21.59 6.75 22 6.75C22.41 6.75 22.75 6.41 22.75 6V2C22.75 1.9 22.73 1.81 22.69 1.71Z" fill="#292D32"></path> </g></svg>
                      </a>
                    </div>
                  </div>

                  <div class="article" v-if="firstFeatures">
                    <div class="article-section">
                      <div class="article-content">
                        <p>Your Dining Companion: Discover, explore, and order from a wide range of restaurants at your fingertips.</p>
                      </div>
                    </div>
                  </div>

                  <div class="article" v-if="secondFatures">
                    <div class="article-section">
                      <div class="article-content">
                        <p>TamaniBook carries a simple UI design. Enjoy a fluid and intuitive navigation system that guides you effortlessly through the app's features and content. </p>
                      </div>
                    </div>
                  </div>

                  <div class="article" v-if="thirdFeatures">
                    <div class="article-section">
                      <div class="article-content">
                        <p>Navigate through our app's settings with ease, thanks to an intuitive and user-centric design. Access and manage all your app settings conveniently from a centralized control panel.</p>
                      </div>
                    </div>
                  </div>

                  <div class="article" v-if="fourthFeatures">
                    <div class="article-section">
                      <div class="article-content">

                        <div class="payment-card">
                          <div class="credit-card">
                            <div class="card__info">
                                <div class="card__logo">MasterCard</div>
                                <div class="card__chip">
                                    <svg class="card__chip-lines" role="img" width="20px" height="20px" viewBox="0 0 100 100" aria-label="Chip">
                                        <g opacity="0.8">
                                            <polyline points="0,50 35,50" fill="none" stroke="#000" stroke-width="2"></polyline>
                                            <polyline points="0,20 20,20 35,35" fill="none" stroke="#000" stroke-width="2"></polyline>
                                            <polyline points="50,0 50,35" fill="none" stroke="#000" stroke-width="2"></polyline>
                                            <polyline points="65,35 80,20 100,20" fill="none" stroke="#000" stroke-width="2"></polyline>
                                            <polyline points="100,50 65,50" fill="none" stroke="#000" stroke-width="2"></polyline>
                                            <polyline points="35,35 65,35 65,65 35,65 35,35" fill="none" stroke="#000" stroke-width="2"></polyline>
                                            <polyline points="0,80 20,80 35,65" fill="none" stroke="#000" stroke-width="2"></polyline>
                                            <polyline points="50,100 50,65" fill="none" stroke="#000" stroke-width="2"></polyline>
                                            <polyline points="65,65 80,80 100,80" fill="none" stroke="#000" stroke-width="2"></polyline>
                                        </g>
                                    </svg>
                                    <div class="card__chip-texture"></div>
                                </div>
                                <div class="card__type">debit</div>
                                <div class="card__number">
                                    <span class="card__digit-group">0123</span>
                                    <span class="card__digit-group">4567</span>
                                    <span class="card__digit-group">8901</span>
                                    <span class="card__digit-group">2345</span>
                                </div>
                                <div class="card__valid-thru" aria-label="Valid thru">Valid<br>thru</div>
                                <div class="card__exp-date"><time datetime="2038-01">01/38</time></div>
                                <div class="card__name" aria-label="Dee Stroyer">Tamani Restaurant</div>
                                <div class="card__vendor" role="img" aria-labelledby="card-vendor">
                                  <span id="card-vendor" class="card__vendor-sr">Mastercard</span>
                                </div>
                                <div class="card__texture"></div>
                            </div>
                          </div>
                          
                        <p class="payment-text">Accepting Card Payment</p>
                        
                      </div>  
                      
                      </div>
                    </div>
                  </div>
                  <a href="#third-section" class="btn navigation-btn btn-second"><span class="icon flaticon-download7"></span>How It's Work</a> </div>
          </div>
      </div>
    </div>
    <div class="third-page">
      <div class="landing-section" id="third-section">
          <div class="wrap">
              <div class="box">

                  <h1>Self Ordering System <strong>QR</strong>Code</h1>
                  <p>A better way to serve our food menu using fully featured Tamani Book Apps,
                  <br>Self-service system that empowers customers to make their own food orders directly on their smartphone without the involvement of a restaurant cashier or waiter</p> 


                  <a href="#fourth-section" class="btn navigation-btn"><span class="icon flaticon-download7"></span>How To Find Us</a> 
              </div>
          </div>
      </div>
    </div>
    <div class="fourth-page">
      <div class="landing-section" id="fourth-section">
          <div class="wrap">
              <div class="box">
                  <h1>Our <strong>Location</strong></h1>
                  <p style="margin-top: -20px">Our restaurant has several branches spread accross Jakarta.</p> 

                  <div class="tamani-card-container" style="margin-top: -20%;">
                    <Splide style="margin-top: -25px" :options="{ rewind: true, 
                                                                  perPage: 1,
                                                                  padding: 20,
                                                                  focus: 'center',
                                                                  pagination: false,
                                                                  type: 'loop', 
                                                                  height: '550px',
                                                                  arrows: true}" aria-label="My Favorite Images">
                        <SplideSlide v-for="res in outlet" :key="res.id">
                          <div class="tamani-card">
                              <div class="circle"></div>
                              <div class="circle"></div>
                              <div class="tamani-card-inner">
                                <img class="location-img" :src="getRestaurantImg(res.image)" alt="">
                                <h3 class="location-name">{{ res.name }}</h3>
                                <p class="location-desc">{{ res.description }}</p>

                                <div class="open-maps-wrapper">
                                  <a :href="res.maps" class="location-map" target=”_blank” >
                                    <div class="maps-loader"></div>
                                    Open Map
                                  </a>
                                </div>
                              </div>
                          </div>
                        </SplideSlide>
                    </Splide>
                  </div>

                  <a href="#fifth-section" style="margin-top: -100px;" class="btn navigation-btn btn-fourth"><span class="icon flaticon-download7"></span>See Details</a> 
              </div>
          </div>
      </div>
    </div>
    <div class="fifth-page">
      <div class="landing-section" id="fifth-section">
          <div class="wrap">
              <div class="box">
                  <h1>Let's Try Our <strong>App</strong></h1>
                  <p>Scan the QR code that given by the waiter, it must be a valid qr code or the system will reject your request.</p> 
                  
                  <div class="camera-container position-relative" v-if="isActiveCamera">
                      <StreamBarcodeReader
                          @decode="onDecode"
                          @loaded="onLoaded"
                      ></StreamBarcodeReader>
                  </div>

                  <button class="btn navigation-btn" style="margin-top: -20px" @click="activateScanner">
                    <span class="icon flaticon-download7"></span>
                    {{ cameraText }}
                  </button>
                  <p>{{ qrText }}</p>

                  <a href="#sixth-section" style="margin-top: 41vh;" class="btn navigation-btn btn-fourth"><span class="icon flaticon-download7"></span>See Gallery</a> 
              </div>
          </div>
      </div>
    </div>
    <div class="sixth-page">
      <div class="landing-section" id="sixth-section">
          <div class="wrap">
              <div class="box">
                  <div class="image-gallery">
                    <div class="gallery">
                      <input type="radio" checked="checked" name="select" id="img-tab-1">
                      <label for="img-tab-1" style="background-image: url(assets/images/gallery/tamani1.jpg);"></label>
                      <img src="assets/images/gallery/tamani1.jpg" alt="tamani1">

                      <input type="radio" name="select" id="img-tab-2">
                      <label for="img-tab-2" style="background-image: url(assets/images/gallery/tamani2.jpg);"></label>
                      <img src="assets/images/gallery/tamani2.jpg" alt="tamani2">

                      <input type="radio" name="select" id="img-tab-3">
                      <label for="img-tab-3" style="background-image: url(assets/images/gallery/tamani3.jpg);"></label>
                      <img src="assets/images/gallery/tamani3.jpg" alt="tamani3">
                      
                      <input type="radio" name="select" id="img-tab-4">
                      <label for="img-tab-4" style="background-image: url(assets/images/gallery/tamani4.jpg);"></label>
                      <img src="assets/images/gallery/tamani4.jpg" alt="tamani4">
                      
                      <input type="radio" name="select" id="img-tab-5">
                      <label for="img-tab-5" style="background-image: url(assets/images/gallery/tamani5.jpg);"></label>
                      <img src="assets/images/gallery/tamani5.jpg" alt="tamani5">
                      
                      <input type="radio" name="select" id="img-tab-6">
                      <label for="img-tab-6" style="background-image: url(assets/images/gallery/tamani6.jpg);"></label>
                      <img src="assets/images/gallery/tamani6.jpg" alt="tamani6">
                      
                      <input type="radio" name="select" id="img-tab-7">
                      <label for="img-tab-7" style="background-image: url(assets/images/gallery/tamani7.jpg);"></label>
                      <img src="assets/images/gallery/tamani7.jpg" alt="tamani7">
                      
                      <input type="radio" name="select" id="img-tab-8">
                      <label for="img-tab-8" style="background-image: url(assets/images/gallery/tamani8.jpg);"></label>
                      <img src="assets/images/gallery/tamani8.jpg" alt="tamani8">
                    </div>
                  </div>
                </div>
          </div>

          <div class="landing-footer">
              <div class="footer-content">
                <div class="footer-card">
                    <h1 style="color: rgb(154,188,22)">TAMANI<span style="color: #ffffff">BOOK</span></h1>
                    <br>
                    <h2>Contact Us</h2>
                    <a href="tel:085778881999">085778881999</a>
                    <a href="mailto:marketing@kafetamani.com" class="email-btn">
                      Email Us
                      <svg width="32px" height="32px" viewBox="0 0 500 500" enable-background="new 0 0 500 500" id="Layer_1" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M415.484,98.802c-32.513-34.721-79.476-7.76-80.147,35.672c-70.075,5.061-140.187,9.532-210.236,14.956 c-17.966,2.95-46.232-2.155-50.804,21.342c-1.24,60.734,2.622,123.439,6.731,184.645c3.626,53.981,13.508,66.33,68.775,60.224 c60.022-3.725,119.983-8.527,180.067-11.174c24.076-3.344,58.891,5.813,72.874-19.608c6.803-69.612-1.65-141.737-8.182-211.589 C422.206,159.684,437.387,125.278,415.484,98.802z" fill="#58454D"></path> <path d="M77.043,200.22c0,0-5.898-37.514,9.685-43.032c15.582-5.518,252.151-20.042,252.151-20.042 c4.725,25.336,29.182,35.889,51.801,32.422v10.905L290.435,263.59l103.159,113.475c0,0,5.993,5.305,4.421,9.628 c-1.572,4.323-3.34,9.825-30.064,11.986c-26.723,2.161-240.453,18.059-255.29,14.639s-21.01-17.39-21.01-17.39 c31.542-38.981,90.779-95.622,122.754-128.713L77.043,200.22z" fill="#F8C795"></path> <path d="M75.948,203.757c1.387,18.645,7.775,165.614,15.704,192.171c27.501-33.603,95.75-100.981,122.754-128.713 L82.009,202.643L75.948,203.757z" fill="#EEB378"></path> <path d="M390.679,180.473c3.311,9.848,11.742,179.35,11.263,196.789c0.003-0.001-3.927,9.431-3.927,9.431 l-2.812-7.957c-24.81-27.197-79.607-87.453-104.769-115.146L390.679,180.473z" fill="#E79959"></path> <path d="M78.493,207.617c14.01,11.338,97.763,32.809,86.448,70.775c-17.928,56.139-43.08,73.162-75.219,106.374 l2.5,10.278c27.972-35.156,90.453-95.77,121.743-128.044c-16.305-7.891-119.075-58.348-132.923-64.358 C81.042,202.643,78.322,204.844,78.493,207.617z" fill="#E79A59"></path> <path d="M300.817,264.081c17.167-21.182,69.385-53.491,72.724,16.452c3.397,37.389,5.486,55.366,1.619,55.317 C371.292,335.801,299.115,270.172,300.817,264.081z" fill="#EEB378"></path> <path d="M421.342,128.644c-0.903,52.885-79.569,52.877-80.464-0.002C341.781,75.759,420.447,75.767,421.342,128.644 z" fill="#EF7F5F"></path> <path d="M361.306,165.467c13.541-28.613,71.728-24.507,43.817-69.473 C446.673,125.25,405.473,189.332,361.306,165.467z" fill="#E86042"></path> <path d="M348.66,397.5c8.827-12.763,18.431-30.272,12.367-46.224c-2.145-5.547-7.057-10.448-7.144-16.586 C383.813,373.199,433.621,397.979,348.66,397.5z" fill="#F5B278"></path> <path d="M382.211,184.244c-23.481-1.585-49.898-19.176-53.68-43.572c-0.063-1.503-1.163-0.848-1.857-1.063 c2.548,0.281,10.199-2.208,10.858,0.681c4.542,18.066,20.276,32.047,38.92,33.776c3.01,1.401,13.335-1.867,13.486,0.914 C391.776,180.301,385.478,181.433,382.211,184.244z" fill="#F5B278"></path> <path d="M290.114,265.562c-43.59,29.075-16.187,30.127-68.243,6.095l0,0c0,0,0,0,0,0c0,0.001,0,0.002,0,0.003 c-1.939-1.313-4.193-1.915-6.217-3.038c-2.967-2.564-4.174,0.662-6.329,2.441c-3.573,3.393-7.276,6.795-10.67,10.423 c20.517-17.927,40.3,13.456,62.018,11.05c19.741-6.929,12.626-16.08,42.436-14.65C299.151,273.383,294.43,269.686,290.114,265.562z " fill="#F5B278"></path> <path d="M80.44,208.491C80.44,208.491,80.44,208.491,80.44,208.491c0,0.01,0,0.019-0.001,0.029 c0.006-0.008,0.013-0.011,0.019-0.018C80.452,208.499,80.446,208.495,80.44,208.491z" fill="#58454D"></path> <path d="M415.484,98.802c-32.513-34.721-79.476-7.76-80.147,35.672c-70.075,5.061-140.187,9.532-210.236,14.956 c-17.966,2.95-46.232-2.155-50.804,21.342c-1.24,60.734,2.622,123.439,6.731,184.645c3.626,53.981,13.508,66.33,68.775,60.224 c60.022-3.725,119.983-8.527,180.067-11.174c24.076-3.344,58.891,5.813,72.874-19.608c6.803-69.612-1.65-141.737-8.182-211.589 C422.206,159.684,437.387,125.278,415.484,98.802z M79.602,198.39c-3.948-33.069,1.459-43.322,36.173-42.84 c73.673-3.927,147.24-10.014,220.881-14.472c16.587,47.003,52.439,26.129,51.346,37.332 c-44.135,32.568-85.588,74.396-129.913,105.57C198.67,255.861,137.943,227.114,79.602,198.39z M92.817,390.914 c-0.665-2.144-0.924-4.199-1.113-6.267c0,0,0,0,0,0c-0.044-0.179-0.088-0.358-0.132-0.537c0,0,0,0,0,0 c-7.701-58.881-8.004-118.475-11.479-177.698c2.571-3.48,30.416,12.844,128.814,59.878 C176.105,306.977,127.444,347.332,92.817,390.914z M394.985,386.587c-12.031,14.276-42.04,7.655-59.379,10.049 c-52.967,1.642-105.775,6.131-158.588,10.288c-22.794-0.661-67.227,14.091-80.923-7.96c-2.497-3.576-2.422-3.553,0.396-6.917 c36.736-41.096,75.699-80.383,114.851-119.111c2.091-1.724,3.251-4.844,6.127-2.363c1.959,1.087,4.142,1.67,6.019,2.941 c0-0.001,0-0.002,0-0.003c0,0,0,0,0,0l0,0c43.69,19.163,26.357,25.786,64.567-5.968c24.75,18.45,45.124,46.642,66.973,69.602v0 C362.693,347.944,395.317,376.665,394.985,386.587z M395.966,289.77c-0.871,30.102,4.838,60.521,2.202,90.333 c-33.718-39.761-68.33-78.598-104.74-115.865c21.112-20.767,48.658-40.084,71.795-60.488c3.874-2.268,21.703-21.151,23.512-17.51 C391.789,220.692,394.85,255.194,395.966,289.77z M419.126,128.862c-8.366,69.663-108.682,31.433-65.848-25.297 C375.498,77.122,420.717,94.233,419.126,128.862z" fill="#58454D"></path> </g> </g></svg>
                    </a>
                    <a>© 2023 Tamani. All rights reserved.</a>
                </div>
                <div class="footer-card" style="margin-left: 40px">
                    <h3>Media</h3>
                    <br>
                    <a href="https://menu.tamani-pos.online">Menu</a> <br>
                    <a href="">Print</a> <br>
                    <a href="">Alternative Ads</a>
                </div>
                <div class="footer-card">
                    <h3>Legal</h3>
                    <br>
                    <a href="">Privacy Policy</a> <br>
                    <a href="">Terms of Use</a> <br>
                    <a href="">Sitemap</a>
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { StreamBarcodeReader } from "vue-barcode-reader";
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import '@splidejs/vue-splide/css/core';

export default {
  name: 'LandingView',
  components: {
    Splide,
    SplideSlide,
    StreamBarcodeReader
  },
  props: ['main'],
  data(){
    return {  
      isActiveCamera: false,
      cameraText: 'Open Camera',
      qrText: null,
      firstFeatures: true,
      secondFatures: false,
      thirdFeatures: false,
      fourthFeatures: false,
      isActive: 'first',
      homePage: true,
      mainPage: false,
      restaurant: [],
      outlet: [],
      servers: '',
      screenposition: 0,
    }
  },
  mounted(){
      this.getRestaurant()
  },
  created(){
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
  },
  methods: {
    handleScroll() {
        this.screenposition = window.scrollY;
    },
    async getRestaurant(){
        try { 
            let { data } = await axios.get('https://api.tamani-pos.online/api/v1/restaurant-outlet')
            this.restaurant = data.data
            this.restaurant.forEach(element => {
                element.outlet.forEach(element => {
                    this.outlet.push(element)
                });
            });
        } catch(e){
            console.log(e)
        }
    },
    activateScanner(){
      if(this.isActiveCamera === false){
        this.isActiveCamera = true;
        this.cameraText = 'Close Camera';
      } else {
        this.isActiveCamera = false;
        this.cameraText = 'Open Camera';
      }
    },
    async onDecode(text){
        console.log(`Decode text from QR code is ${text}`)
        let arrText = text.split("=");
        
        try {
          const decode = atob(arrText[1]);
          const arrData = decode.split(";");
          this.servers = 'https://' + arrData[0] + '/api/web';  
          await axios.get(this.servers + '/home/' + arrText[1]);
          this.$router.push({name: 'Branch', query:{scr: arrText[1]}});            
        } catch(e){
          window.navigator.vibrate(300);
          alert('Invalid QR Code'); 
        }
    },
    first(){
      this.isActive = 'first';
      this.firstFeatures = true;
      this.secondFatures = false;
      this.thirdFeatures = false;
      this.fourthFeatures = false;
    },
    second(){
      this.isActive = 'second';
      this.firstFeatures = false;
      this.secondFatures = true;
      this.thirdFeatures = false;
      this.fourthFeatures = false;
    },
    third(){
      this.isActive = 'third';
      this.firstFeatures = false;
      this.secondFatures = false;
      this.thirdFeatures = true;
      this.fourthFeatures = false;
    },
    fourth(){
      this.isActive = 'fourth';
      this.firstFeatures = false;
      this.secondFatures = false;
      this.thirdFeatures = false;
      this.fourthFeatures = true;
    },
    sMainPage(params){
      this.homePage = false;
      this.mainPage = params;
    },
    getRestaurantImg(filename){
      return 'https://api.tamani-pos.online/assets/images/restaurant/' + filename;
    }
  }
}
</script>

<style>
@font-face {
    font-family: 'walkway_semiboldregular';
    src: url('../assets/fonts/Walkway_SemiBold-webfont.eot');
    src: url('../assets/fonts/Walkway_SemiBold-webfont.eot?#iefix') format('embedded-opentype'), url('../assets/fonts/Walkway_SemiBold-webfont.woff') format('woff'), url('../assets/fonts/Walkway_SemiBold-webfont.ttf') format('truetype'), url('../assets/fonts/Walkway_SemiBold-webfont.svg#walkway_semiboldregular') format('svg');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'walkway_ultraboldregular';
    src: url('../assets/fonts/Walkway_UltraBold-webfont.eot');
    src: url('../assets/fonts/Walkway_UltraBold-webfont.eot?#iefix') format('embedded-opentype'), url('../assets/fonts/Walkway_UltraBold-webfont.woff') format('woff'), url('../assets/fonts/Walkway_UltraBold-webfont.ttf') format('truetype'), url('../assets/fonts/Walkway_UltraBold-webfont.svg#walkway_ultraboldregular') format('svg');
    font-weight: normal;
    font-style: normal;
}

.box h1 {
    color: #ffffff;
    margin-bottom: 30px;
    font-size: 25pt;
    font-weight: normal;
    font-family: 'walkway_semiboldregular';
    line-height: 1.2;
    text-align: center;
}

.box p {
    color: #ffffff;
    margin-bottom: 30px;
    font-size: 13pt;
    font-weight: normal;
    font-family: 'walkway_semiboldregular';
    line-height: 1.2;
    text-align: center;
}

.tamani {
    position: fixed;
    z-index: 101;
    top : 30px;
    left: 50%;
    -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
    color: rgb(154, 188, 22);
    margin-bottom: 30px;
    font-size: 25pt;
    font-weight: bolder;
    font-family: 'walkway_ultraboldregular';
    line-height: 1.2;
    text-align: center;
}

.restaurant {
    color: #ffffff;
    margin-bottom: 30px;
    font-size: 25pt;
    font-weight: bolder;
    font-family: 'walkway_ultraboldregular';
    line-height: 1.2;
    text-align: center;
}

/* first page */
.first-page {
  position: relative;
  display: flex;
  align-content: center;
  top: 0;
  left: 50%;
  background-color: rgba(0, 0, 0, 0.638);
  background-image: url('@/assets/backgrounds/first-page.jpg');
  background-size: 100% 100%;
  object-fit: cover;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
}

.first-page .landing-section {
  position: relative;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  animation: blink 5s ease infinite;
}


.first-page .landing-section .wrap .box{
  position: fixed;
  width: 80%;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}

@keyframes blink{
  0%{background-color: rgba(0, 0, 0, 0.25);}
  25%{background-color: rgba(0, 0, 0, 0.50);}
  50%{background-color: rgba(0, 0, 0, 0.75);}
  75%{background-color: rgba(0, 0, 0, 0.50);}
  100%{background-color: rgba(0, 0, 0, 0.25);}
}

@media only screen and (max-height: 767px){  
  .first-page .landing-section .wrap {
    margin-top: 30%;
  }

  .first-page .landing-section .wrap .box{
    top: 30%;
  }
}

@media (min-height: 768px){ 
  .first-page .landing-section .wrap {
    margin-top: 50%;
  }

  .first-page .landing-section .wrap .box{
    top: 50%;
  }
}

/* second page */
.second-page {
  position: relative;
  display: flex;
  align-content: center;
  top: 0;
  left: 50%;
  background-color: rgba(0, 0, 0, 0.638);
  background-image: url('@/assets/backgrounds/second-page.jpg');
  background-size: 100% 100%;
  object-fit: cover;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
}

.second-page .landing-section {
  position: relative;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  animation: blink 5s ease infinite;
}

@keyframes blink{
  0%{background-color: rgba(0, 0, 0, 0.25);}
  25%{background-color: rgba(0, 0, 0, 0.50);}
  50%{background-color: rgba(0, 0, 0, 0.75);}
  75%{background-color: rgba(0, 0, 0, 0.50);}
  100%{background-color: rgba(0, 0, 0, 0.25);}
}

.btn-second{
  margin-top: 31vh;
}

.about-buttons {
  position: relative;
  left: 50%;
  -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(154, 188, 22, 0.5);
  box-shadow: 0px 0px 15px #00000027;
  width: 300px;
  padding: 7px 5px;
  border-radius: 5em;
}

.about-card-container{
  position: relative;
  top: 0;
  width: 100%;
}

.article{
  position: absolute;
  width: 90%;
  left: 50%;
  -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
  margin-top: 20px;
}

.second-page .landing-section .wrap .box{
  position: fixed;
  width: 80%;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}

@media only screen and (max-height: 700px){  
  .second-page .landing-section .wrap {
    margin-top: 30%;
  }

  .second-page .landing-section .wrap .box{
    top: 15%;
  }

  .about-card-container{
    top: 0;
  }

  .article{
    margin-top: 50px;
  }
}

@media (min-height: 700px){ 
  .second-page .landing-section .wrap {
    margin-top: 30%;
  }

  .second-page .landing-section .wrap .box{
    top: 30%;
  }
}

@media (min-height: 700px) and (max-height: 960px){  
  .about-card-container{
    top: 0;
  }

  .article{
    margin-top: 30px;
  }
}

@media (min-height: 960px){  
  .about-card-container{
    top: 0;
  }

  .about-buttons {
    margin-top: 50px;
  }

  .article{
    margin-top: 40px;
  }
}

.payment-card{
  position: fixed;
  left: 50%;
  z-index: 200;
  -webkit-transform: translateX(-50%);
              transform: translateX(-50%);
}

.payment-text{
  font-size: 30pt;
  font-weight: bolder;
  font-family: 'walkway_ultraboldregular';
  line-height: 1.2;
  text-align: center;
}

.about-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 5px 15px;
  background-color: #fff;
  box-shadow: 0px 0px 4px #00000027;
  transition: 0.3s;
}

.about-button:hover {
  background-color: #fe7f00;
  box-shadow: 0px 0px 6px 3px #00000027;
}

.active {
  background-color: #fe7f00;
  box-shadow: 0px 0px 6px 3px #00000027;
}

.about-buttons svg {
  transition: 0.3s;
  height: 20px;
}

.credit-card,
.card__chip {
  overflow: hidden;
  position: relative;
}

.credit-card,
.card__chip-texture,
.card__texture {
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

.credit-card {
  animation-name: rotate_500;
  background-color: #000000;
  background-image: radial-gradient(circle at 100% 0%,hsla(0,0%,100%,0.08) 29.5%,hsla(0,0%,100%,0) 30%),
                    radial-gradient(circle at 100% 0%,hsla(0,0%,100%,0.08) 39.5%,hsla(0,0%,100%,0) 40%),
                    radial-gradient(circle at 100% 0%,hsla(0,0%,100%,0.08) 49.5%,hsla(0,0%,100%,0) 50%);
  border-radius: 0.5em;
  box-shadow: 0 0 0 hsl(0,0%,80%),
        0 0 0 hsl(0,0%,100%),
        -0.2rem 0 0.75rem 0 hsla(0,0%,0%,0.3);
  color: hsl(0,0%,100%);
  width: 10.3em;
  height: 6.8em;
  transform: translate3d(0,0,0);
}

.card__info,
.card__chip-texture,
.card__texture {
  position: absolute;
}

.card__chip-texture,
.card__texture {
  animation-name: texture;
  top: 0;
  left: 0;
  width: 200%;
  height: 100%;
}

.card__info {
  font: 0.75em/1 "DM Sans", sans-serif;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.75rem;
  inset: 0;
}

.card__logo,
.card__number {
  width: 100%;
}

.card__logo {
  font-weight: bold;
  font-style: italic;
}

.card__chip {
  background-image: linear-gradient(hsl(0,0%,70%),hsl(0,0%,80%));
  border-radius: 0.2rem;
  box-shadow: 0 0 0 0.05rem hsla(0,0%,0%,0.5) inset;
  width: 1.25rem;
  height: 1.25rem;
  transform: translate3d(0,0,0);
}

.card__chip-lines {
  width: 100%;
  height: auto;
}

.card__chip-texture {
  background-image: linear-gradient(-80deg,hsla(0,0%,100%,0),hsla(0,0%,100%,0.6) 48% 52%,hsla(0,0%,100%,0));
}

.card__type {
  align-self: flex-end;
  margin-left: auto;
}

.card__digit-group,
.card__exp-date,
.card__name {
  background: linear-gradient(hsl(0,0%,100%),hsl(0,0%,85%) 15% 55%,hsl(0,0%,70%) 70%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Courier Prime", monospace;
  filter: drop-shadow(0 0.05rem hsla(0,0%,0%,0.3));
}

.card__number {
  font-size: 0.8rem;
  display: flex;
  justify-content: space-between;
}

.card__valid-thru,
.card__name {
  text-transform: uppercase;
}

.card__valid-thru,
.card__exp-date {
  margin-bottom: 0.25rem;
  width: 50%;
}

.card__valid-thru {
  font-size: 0.3rem;
  padding-right: 0.25rem;
  text-align: right;
}

.card__exp-date,
.card__name {
  font-size: 0.6rem;
}

.card__exp-date {
  padding-left: 0.25rem;
}

.card__name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 6.25rem;
}

.card__vendor,
.card__vendor:before,
.card__vendor:after {
  position: absolute;
}

.card__vendor {
  right: 0.375rem;
  bottom: 0.375rem;
  width: 2.55rem;
  height: 1.5rem;
}

.card__vendor:before,
.card__vendor:after {
  border-radius: 50%;
  content: "";
  display: block;
  top: 0;
  width: 1.5rem;
  height: 1.5rem;
}

.card__vendor:before {
  background-color: #e71d1a;
  left: 0;
}

.card__vendor:after {
  background-color: #fa5e03;
  box-shadow: -1.05rem 0 0 #f59d1a inset;
  right: 0;
}

.card__vendor-sr {
  clip: rect(1px,1px,1px,1px);
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.card__texture {
  animation-name: texture;
  background-image: linear-gradient(-80deg,hsla(0,0%,100%,0.3) 25%,hsla(0,0%,100%,0) 45%);
}
 
/* Dark theme */
@media (prefers-color-scheme: dark) {
  :root {
    --bg: hsl(var(--hue),10%,30%);
    --fg: hsl(var(--hue),10%,90%);
  }
}

/* Animation */
@keyframes rotate_500 {
  from,
    to {
    animation-timing-function: ease-in;
    box-shadow: 0 0 0 hsl(0,0%,80%),
            0.1rem 0 0 hsl(0,0%,100%),
            -0.2rem 0 0.75rem 0 hsla(0,0%,0%,0.3);
    transform: rotateY(-10deg);
  }

  25%,
    75% {
    animation-timing-function: ease-out;
    box-shadow: 0 0 0 hsl(0,0%,80%),
            0 0 0 hsl(0,0%,100%),
            -0.25rem -0.05rem 1rem 0.15rem hsla(0,0%,0%,0.3);
    transform: rotateY(0deg);
  }

  50% {
    animation-timing-function: ease-in;
    box-shadow: -0.1rem 0 0 hsl(0,0%,80%),
            0 0 0 hsl(0,0%,100%),
            -0.3rem -0.1rem 1.5rem 0.3rem hsla(0,0%,0%,0.3);
    transform: rotateY(10deg);
  }
}

@keyframes texture {
  from,
    to {
    transform: translate3d(0,0,0);
  }

  50% {
    transform: translate3d(-50%,0,0);
  }
}

/* third section */
.third-page {
  position: relative;
  display: flex;
  align-content: center;
  top: 0;
  left: 50%;
  background-color: rgba(0, 0, 0, 0.638);
  background-image: url('@/assets/backgrounds/third-page.jpg');
  background-size: 100% 100%;
  object-fit: cover;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
}

.third-page .landing-section {
  position: relative;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  animation: blink 5s ease infinite;
}

@keyframes blink{
  0%{background-color: rgba(0, 0, 0, 0.25);}
  25%{background-color: rgba(0, 0, 0, 0.50);}
  50%{background-color: rgba(0, 0, 0, 0.75);}
  75%{background-color: rgba(0, 0, 0, 0.50);}
  100%{background-color: rgba(0, 0, 0, 0.25);}
}

.btn-third{
  margin-top: 77vh;
}

@media only screen and (max-height: 700px){  
  .third-page .landing-section .wrap {
    margin-top: 30%;
  }

  .third-page .landing-section .wrap .box{
    position: fixed;
    width: 80%;
    top: 10%;
    left: 50%;
    -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
  }

  .btn-third{
    margin-top: 75vh;
  }
}

@media (max-width: 767px) and (min-height: 701px){ 
  .third-page .landing-section .wrap {
    margin-top: 50%;
  }

  .third-page .landing-section .wrap .box{
    position: fixed;
    width: 80%;
    top: 10%;
    left: 50%;
    -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
  }
}

@media (min-width: 768px) and (min-height: 701px){ 
  .third-page .landing-section .wrap {
    margin-top: 50%;
  }

  .third-page .landing-section .wrap .box{
    position: fixed;
    width: 80%;
    top: 10%;
    left: 50%;
    -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
  }
}
  
/* fourth page */
.fourth-page {
  position: relative;
  display: flex;
  align-content: center;
  top: 0;
  left: 50%;
  background-color: rgba(0, 0, 0, 0.638);
  background-image: url('@/assets/backgrounds/fourth-page.jpg');
  background-size: 100% 100%;
  object-fit: cover;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
}

.fourth-page .landing-section {
  position: relative;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  animation: blink 5s ease infinite;
}

.fourth-page .landing-section .wrap .box{
  position: fixed;
  width: 80%;
  top: 30%;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}

@keyframes blink{
  0%{background-color: rgba(0, 0, 0, 0.25);}
  25%{background-color: rgba(0, 0, 0, 0.50);}
  50%{background-color: rgba(0, 0, 0, 0.75);}
  75%{background-color: rgba(0, 0, 0, 0.50);}
  100%{background-color: rgba(0, 0, 0, 0.25);}
}

.btn-fourth{
  margin-top: 0;
}

@media only screen and (max-height: 700px){  
  .fourth-page .landing-section .wrap {
    margin-top: 30%;
  }

  .fourth-page .landing-section .wrap .box{
    top: 10%;
  }
}

@media (min-height: 700px) and (max-height: 860px){
  .fourth-page .landing-section .wrap {
    margin-top: 30%;
  }

  .fourth-page .landing-section .wrap .box{
    top: 10%;
  }

  .btn-fourth{
    margin-top: -30px;
  }
}

@media (min-height: 860px){ 
  .fourth-page .landing-section .wrap {
    margin-top: 50%;
  }

  .fourth-page .landing-section .wrap .box{
    top: 10%;
  }
  .btn-fourth{
    margin-top: 20px;
  }  
}

.tamani-card-container{
  position: relative;
  margin-top: 50px;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  width: 110%;
  height: 100%;
}

.tamani-card {
  margin: 50px auto;
  margin-top: 50px;
  width: 300px;
  height: 430px;
  transition: all 0.2s;
  position: relative;
  cursor: pointer;
}

.tamani-card-inner {
  width: inherit;
  height: inherit;
  background: rgba(255,255,255,.05);
  box-shadow: 0 0 10px rgba(0,0,0,0.25);
  backdrop-filter: blur(10px);
  border-radius: 8px;
}

.tamani-card:hover {
  transform: scale(1.04) rotate(1deg);
}

.circle {
  width: 100px;
  height: 100px;
  background: radial-gradient(#b0e633, rgb(154, 188, 22));
  border-radius: 50%;
  position: absolute;
  animation: move-up6 2.5s ease-in infinite alternate-reverse;
}

.circle:nth-child(1) {
  top: -25px;
  left: -25px;
}

.circle:nth-child(2) {
  bottom: -25px;
  right: -25px;
  animation-name: move-down1;
}

@keyframes move-up6 {
  to {
    transform: translateY(-10px);
    opacity: 0.3;
  }
}

@keyframes move-down1 {
  to {
    transform: translateY(10px);
    opacity: 0.3;
  }
}

.location-img{
  width: 90%;
  height: 200px;
  object-fit: cover;
  margin-top: 10px;
  border-radius:10px;
  border: 2px solid #ffffff;
}

.location-name{
  margin-top: 10px; 
  color:#ffffff; 
  font-weight: bolder
}

.location-desc{
  width: 90%;
  margin: 5px auto;
  margin-top: 10px
}

.location-map{
  width: 170px;
  height: 40px;
  background-color: #79d000;
  border-radius: 10px;
  padding: 5px 0;
  padding-right: 10px;
  color: #ffffff;
  font-size: 12pt;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
  align-items: center;
}

.location-map:hover{
  background-color: #4a8000;
}

.open-maps-wrapper{
    position: relative;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
            transfrom: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
}

.maps-loader {
  width: 25px;
  height: 25px;
  position: fixed;
  top: 4px;
  margin-left: 7px;
  transform: rotate(45deg);
}

.maps-loader:before,
.maps-loader:after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50% 50% 0 50%;
  background: #0000;
  background-image: radial-gradient(circle 6px at 50% 50%,#ffffff 94%, #ff4747);
}

.maps-loader:after {
  animation: pulse-ytk0dhmd 1s infinite;
  transform: perspective(336px) translateZ(0px);
}

@keyframes pulse-ytk0dhmd {
  to {
    transform: perspective(336px) translateZ(168px);
    opacity: 0;
  }
}


/* fifth page */
.fifth-page {
  position: relative;
  display: flex;
  align-content: center;
  top: 0;
  left: 50%;
  background-color: rgba(0, 0, 0, 0.638);
  background-image: url('@/assets/backgrounds/fifth-page.jpg');
  background-size: 100% 100%;
  object-fit: cover;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
}

.fifth-page .landing-section {
  position: relative;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  animation: blink 5s ease infinite;
}


.fifth-page .landing-section .wrap .box{
  position: fixed;
  width: 80%;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}

@keyframes blink{
  0%{background-color: rgba(0, 0, 0, 0.25);}
  25%{background-color: rgba(0, 0, 0, 0.50);}
  50%{background-color: rgba(0, 0, 0, 0.75);}
  75%{background-color: rgba(0, 0, 0, 0.50);}
  100%{background-color: rgba(0, 0, 0, 0.25);}
}

@media only screen and (max-height: 700px){  
  .fifth-page .landing-section .wrap {
    margin-top: 30%;
  }

  .fifth-page .landing-section .wrap .box{
    top: 10%;
  }
}

@media (min-height: 700px){ 
  .fifth-page .landing-section .wrap {
    margin-top: 50%;
  }

  .fifth-page .landing-section .wrap .box{
    top: 10%;
  }
}

.camera-container{
  position: relative;
  top: 30px;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}


.continue-application {
  --color: #fff;
  --background: #79d000;
  --background-hover: #2a4700;
  --background-left: #2a4700;
  --folder: #F3E9CB;
  --folder-inner: #BEB393;
  --paper: #FFFFFF;
  --paper-lines: #BBC1E1;
  --paper-behind: #E1E6F9;
  --pencil-cap: #fff;
  --pencil-top: #275EFE;
  --pencil-middle: #fff;
  --pencil-bottom: #5C86FF;
  --shadow: rgba(13, 15, 25, .2);
  border: none;
  outline: none;
  cursor: pointer;
  position: fixed;
  bottom: 10%;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  padding: 17px 29px 17px 69px;
  transition: background 0.3s;
  color: var(--color);
  background: var(--bg, var(--background));
}

.continue-application > div {
  top: 0;
  left: 0;
  bottom: 0;
  width: 53px;
  position: absolute;
  overflow: hidden;
  border-radius: 5px 0 0 5px;
  background: var(--background-left);
}

.continue-application > div .folder {
  width: 23px;
  height: 27px;
  position: absolute;
  left: 15px;
  top: 13px;
}

.continue-application > div .folder .top {
  left: 0;
  top: 0;
  z-index: 2;
  position: absolute;
  transform: translateX(var(--fx, 0));
  transition: transform 0.4s ease var(--fd, 0.3s);
}

.continue-application > div .folder .top svg {
  width: 24px;
  height: 27px;
  display: block;
  fill: var(--folder);
  transform-origin: 0 50%;
  transition: transform 0.3s ease var(--fds, 0.45s);
  transform: perspective(120px) rotateY(var(--fr, 0deg));
}

.continue-application > div .folder:before, .continue-application > div .folder:after,
.continue-application > div .folder .paper {
  content: "";
  position: absolute;
  left: var(--l, 0);
  top: var(--t, 0);
  width: var(--w, 100%);
  height: var(--h, 100%);
  border-radius: 1px;
  background: var(--b, var(--folder-inner));
}

.continue-application > div .folder:before {
  box-shadow: 0 1.5px 3px var(--shadow), 0 2.5px 5px var(--shadow), 0 3.5px 7px var(--shadow);
  transform: translateX(var(--fx, 0));
  transition: transform 0.4s ease var(--fd, 0.3s);
}

.continue-application > div .folder:after,
.continue-application > div .folder .paper {
  --l: 1px;
  --t: 1px;
  --w: 21px;
  --h: 25px;
  --b: var(--paper-behind);
}

.continue-application > div .folder:after {
  transform: translate(var(--pbx, 0), var(--pby, 0));
  transition: transform 0.4s ease var(--pbd, 0s);
}

.continue-application > div .folder .paper {
  z-index: 1;
  --b: var(--paper);
}

.continue-application > div .folder .paper:before, .continue-application > div .folder .paper:after {
  content: "";
  width: var(--wp, 14px);
  height: 2px;
  border-radius: 1px;
  transform: scaleY(0.5);
  left: 3px;
  top: var(--tp, 3px);
  position: absolute;
  background: var(--paper-lines);
  box-shadow: 0 12px 0 0 var(--paper-lines), 0 24px 0 0 var(--paper-lines);
}

.continue-application > div .folder .paper:after {
  --tp: 6px;
  --wp: 10px;
}

.continue-application > div .pencil {
  height: 2px;
  width: 3px;
  border-radius: 1px 1px 0 0;
  top: 8px;
  left: 105%;
  position: absolute;
  z-index: 3;
  transform-origin: 50% 19px;
  background: var(--pencil-cap);
  transform: translateX(var(--pex, 0)) rotate(35deg);
  transition: transform 0.4s ease var(--pbd, 0s);
}

.continue-application > div .pencil:before, .continue-application > div .pencil:after {
  content: "";
  position: absolute;
  display: block;
  background: var(--b, linear-gradient(var(--pencil-top) 55%, var(--pencil-middle) 55.1%, var(--pencil-middle) 60%, var(--pencil-bottom) 60.1%));
  width: var(--w, 5px);
  height: var(--h, 20px);
  border-radius: var(--br, 2px 2px 0 0);
  top: var(--t, 2px);
  left: var(--l, -1px);
}

.continue-application > div .pencil:before {
  -webkit-clip-path: polygon(0 5%, 5px 5%, 5px 17px, 50% 20px, 0 17px);
  clip-path: polygon(0 5%, 5px 5%, 5px 17px, 50% 20px, 0 17px);
}

.continue-application > div .pencil:after {
  --b: none;
  --w: 3px;
  --h: 6px;
  --br: 0 2px 1px 0;
  --t: 3px;
  --l: 3px;
  border-top: 1px solid var(--pencil-top);
  border-right: 1px solid var(--pencil-top);
}

.continue-application:before, .continue-application:after {
  content: "";
  position: absolute;
  width: 10px;
  height: 2px;
  border-radius: 1px;
  background: var(--color);
  transform-origin: 9px 1px;
  transform: translateX(var(--cx, 0)) scale(0.5) rotate(var(--r, -45deg));
  top: 26px;
  right: 16px;
  transition: transform 0.3s;
}

.continue-application:after {
  --r: 45deg;
}

.continue-application:hover {
  --cx: 2px;
  --bg: var(--background-hover);
  --fx: -40px;
  --fr: -60deg;
  --fd: .15s;
  --fds: 0s;
  --pbx: 3px;
  --pby: -3px;
  --pbd: .15s;
  --pex: -24px;
}

/* social-btn */
.share-btn{
  position: fixed;
  bottom: 10px;
  left: 50%;
  z-index: 200;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}

.social-links, .flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.social-btn {
  bottom: 0;
  cursor: pointer;
  height: 30px;
  width: 30px;
  font-family: 'Titillium Web', sans-serif;
  color: #333;
  border-radius: 10px;
  box-shadow: 0px 10px 10px rgba(0,0,0,0.1);
  background: #ffffff6f;
  margin: 5px;
  transition: 0.3s;
  justify-content: center;
}

.social-btn svg {
  height: 16px;
  width: 16px;
  margin-left: 8px;
}

.social-btn span {
  width: 0px;
  overflow: hidden;
  transition: 0.3s;
  text-align: center;
  margin-left: 5px;
  font-size: 9pt;
}

.social-btn:hover {
  width: 130px;
  border-radius: 5px;
}

.social-btn:hover span {
  padding: 2px;
  width: 80px;
  font-size: 9pt;
}

#twitter svg {
  fill: #1da1f2;
}

@keyframes scrolling13 {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }

  100% {
    opacity: 1;
    transform: translateY(20px);
  }
}

/* sixth page */
.sixth-page {
  position: relative;
  display: flex;
  align-content: center;
  top: 0;
  left: 50%;
  background-color: rgba(0, 0, 0, 0.638);
  background-image: url('@/assets/backgrounds/sixth-page.jpg');
  background-size: 100% 100%;
  object-fit: cover;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
}

.sixth-page .landing-section {
  position: relative;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  max-width: 767px;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  animation: blink 5s ease infinite;
}


.sixth-page .landing-section .wrap .box{
  position: fixed;
  width: 80%;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}

@keyframes blink{
  0%{background-color: rgba(0, 0, 0, 0.25);}
  25%{background-color: rgba(0, 0, 0, 0.50);}
  50%{background-color: rgba(0, 0, 0, 0.75);}
  75%{background-color: rgba(0, 0, 0, 0.50);}
  100%{background-color: rgba(0, 0, 0, 0.25);}
}

@media only screen and (max-height: 700px){  
  .sixth-page .landing-section .wrap {
    margin-top: 30%;
  }

  .sixth-page .landing-section .wrap .box{
    top: 10%;
  }
}

@media (min-height: 700px){ 
  .sixth-page .landing-section .wrap {
    margin-top: 50%;
  }

  .sixth-page .landing-section .wrap .box{
    top: 15%;
  }
}

/* sixth section gallery */
.image-gallery{
  margin-top: -50px;
}

.gallery {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-row-end: 3;
  align-content: start;
  max-width: 550px;
  margin: 0 auto;
  transition: all 150ms linear;
}

.gallery input[type="radio"] {
  display: none;
}

.gallery label {
  position: relative;
  display: block;
  padding-bottom: 60%;
  margin: 5px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}

.gallery label:before {
  border: 1px solid #e3e3e3;
  content: '';
  position: absolute;
  left: -5px;
  right: -5px;
  bottom: -5px;
  top: -5px;
}

.gallery img {
  display: none;
  grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 2;
  width: 100%;
  transition: all 150ms linear;
  border: 2px solid #e3e3e3;
}

.gallery input[name="select"]:checked + label + img {
  display: block;
}

.gallery input[name="select"]:checked + label:before {
  border: 1px solid #000;
}

/* sixth section footer */
.landing-footer{
  position: fixed;
  bottom: 0;
  z-index:80;
  width:100%;
  height: 200px;
  background-color: #111111;
}

.footer-content{
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
}

.footer-card{
  width: 30%;
  margin: 5px 0;
  color: #ffffff;
  text-align: left;
  margin-left: 15px;
}

.footer-card h1 {
  font-size: 15pt;
  font-weight: bolder;
  font-family: 'walkway_ultraboldregular';
  line-height: 1.2;
}

.footer-card h2 {
  font-size: 13pt;
  font-weight: bolder;
  font-family: 'walkway_ultraboldregular';
  line-height: 1.2;
}

.footer-card h3 {
  margin-top: 2px;
  font-size: 12pt;
  font-weight: bolder;
  font-family: 'walkway_semiboldregular';
  line-height: 1.2;
}

.footer-card a {
  margin-top: 2px;
  font-size: 10pt;
  font-weight: bolder;
  font-family: 'walkway_semiboldregular';
  line-height: 1.2;
  color: #ffffff;
}

.footer-card a:hover {
  color: #ff6600;
}

.email-btn {
  width: 130px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(61, 61, 61);
  border: none;
  color: white;
  font-weight: 600;
  gap: 8px;
  cursor: pointer;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.103);
  position: relative;
  overflow: hidden;
  transition-duration: .3s;
}

.svgIcon {
  width: 16px;
}

.svgIcon path {
  fill: white;
}

.email-btn::before {
  width: 130px;
  height: 130px;
  position: absolute;
  content: "";
  background-color: white;
  border-radius: 50%;
  left: -100%;
  top: 0;
  transition-duration: .3s;
  mix-blend-mode: difference;
}

.email-btn:hover::before {
  transition-duration: .3s;
  transform: translate(100%,-50%);
  border-radius: 0;
}

.email-btn:active {
  transform: translate(5px,5px);
  transition-duration: .3s;
}

/* navigation btn */
.navigation-btn {
  border-radius: .25rem;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 400;
  padding-left: 25px;
  padding-right: 25px;
  color: #fff;
  -webkit-clip-path: polygon(0 0,0 0,100% 0,100% 0,100% calc(100% - 15px),calc(100% - 15px) 100%,15px 100%,0 100%);
  clip-path: polygon(0 0,0 0,100% 0,100% 0,100% calc(100% - 15px),calc(100% - 15px) 100%,15px 100%,0 100%);
  height: 40px;
  font-size: 0.7rem;
  line-height: 14px;
  letter-spacing: 1.2px;
  transition: .2s .1s;
  background-image: linear-gradient(90deg,#2a4700,#79d000);
  border: 0 solid;
  overflow: hidden;
  z-index: 100;
}

.navigation-btn:hover {
  color: #ff5900;
  background-image: linear-gradient(90deg,#0d1600,#325500);
  cursor: pointer;
  transition: all .3s ease-in;
  padding-right: 30px;
  padding-left: 30px;
}

/* back to top btn */
@media only screen and (max-width: 800px){
  .btn-top{
    position: fixed;
    bottom: 50px;
    right: 30px;
    z-index: 200;
  }

  .Btn {
    position: relative;
    width: 45px;
    height: 45px;
    background-color: rgba(154, 188, 22, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
  }

  .arrow path {
    fill: white;
  }

  .text {
    font-size: 0.7em;
    width: 100px;
    position: absolute;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: -18px;
    opacity: 1;
    transition-duration: .7s;
  }

  .Btn:active .text {
    opacity: 1;
    transition-duration: .7s;
  }

  .Btn:active .arrow {
    animation: slide-in-bottom .7s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }

  @keyframes slide-in-bottom {
    0% {
      transform: translateY(10px);
      opacity: 0;
    }

    100% {
      transform: translateY(0);
      opacity: 1;
    }
  } 
}

@media (min-width: 800px){
  .btn-top{
    position: fixed;
    opacity: 0;
  }
}
</style>